module.exports = __webpack_public_path__ + "static/img/img-Analysis2.c29f846.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-Analysis2.png
// module id = dpxD
// module chunks = 1